var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgoralogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 285.52 137.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke:#060300;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "igoralogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    y1: 1.77,
    x2: 1,
    y2: 60.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.81,22.19C72.81,15.48,64.55,4,44.16,4s-31,12.65-31,31.48S29.45,64.39,43.77,64.39s30.71-7.23,30.71-27.87H46.61",
    transform: "translate(-3.16 -2.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.84,33.68c0-12.26-7.87-30.07-31.1-30.07s-31,18.84-31,30.2,8.52,30.45,30.33,30.45S145.84,48.77,145.84,33.68Z",
    transform: "translate(-3.16 -2.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.45,108.52c0-12.26-7.87-30.07-31.1-30.07s-31,18.84-31,30.2S71.9,139.1,93.71,139.1,125.45,123.61,125.45,108.52Z",
    transform: "translate(-3.16 -2.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.74,63.35V5.29L192,5.42S203.9,4.9,203.9,20s-15.22,14.84-15.22,14.84l-33.16-.26",
    transform: "translate(-3.16 -2.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.55,138.32V80.26l37.29.13S53.71,79.87,53.71,95s-15.23,14.84-15.23,14.84l-33.16-.26",
    transform: "translate(-3.16 -2.61)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "205.65 60.61 233.78 2.42 262.29 60.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 216.23,
    y1: 40.48,
    x2: 251.97,
    y2: 40.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "179.58 135.45 207.71 77.26 236.23 135.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 190.16,
    y1: 115.32,
    x2: 225.91,
    y2: 115.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "243.46 76.74 243.46 134.55 285.52 134.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "126.68 77 155.07 110.03 155.07 135.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 183.45,
    y1: 76.87,
    x2: 154.94,
    y2: 110.29
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.9,34.84s20.52-.13,22.33,6.06c1.85,6.35-.91,17.81,1.93,22.33",
    transform: "translate(-3.16 -2.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.71,109.81s20.52-.13,22.32,6.06c1.85,6.35-.9,17.81,1.94,22.32",
    transform: "translate(-3.16 -2.61)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgoralogo);
export default __webpack_public_path__ + "static/media/igoralogo.8e15a5aa1ecaeacc88605262eb92328e.svg";
export { ForwardRef as ReactComponent };